import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 420px;
  > div > div > div {
    overflow-x: visible;
  }
  padding-bottom: 24px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;
